/* unplugin-vue-components disabled */import script from "./PriceBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./PriceBlock.vue?vue&type=script&setup=true&lang=js"

import "./PriceBlock.vue?vue&type=style&index=0&id=5e4e07de&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e4e07de"]])

export default __exports__